import React from "react";
import { MailIcon, PhoneIcon, ShieldCheckIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { ui } from "../data/ui";
import { ContactForm } from "./ContactForm";
import { LocationMap } from "./LocationMap";
import { Reveal } from "./Reveal";
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" aria-labelledby="contact-title" className="border-t-4 border-gold bg-ink py-20 lg:py-28" data-id="element-51" data-mp="3sxzkngdby4qa">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-52" data-mp="3oxfnicsrb145">
        <Reveal className="text-center" data-id="element-53" data-mp="3k5fp4osc4g9o">
          <h2 id="contact-title" className="font-display text-4xl font-extrabold uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-54" data-mp="3k44ogxu6roms">
            {t(ui.contact.title)}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-smoke" data-id="element-55" data-mp="ggktlmtxsr27">{t(ui.contact.subtitle)}</p>
        </Reveal>

        <Reveal className="mt-12 grid gap-4 md:grid-cols-5" data-id="element-56" data-mp="bokxk5gzmiaw">
          <a href={business.phoneHref} className="flex items-center gap-4 rounded-sm bg-gold px-6 py-5 text-ink transition-[background-color,box-shadow] duration-150 ease-out hover:bg-gold-bright hover:shadow-glow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white md:col-span-3" data-id="element-57" data-mp="3jvl3ksvq1cq5">
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-ink text-gold" data-id="element-58" data-mp="3f3t9w9h9qqvs">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="314bqyaqnm7uc" />
            </span>
            <span data-id="element-60" data-mp="3657sihnj9hwl">
              <span className="block text-xs font-bold uppercase tracking-[0.16em]" data-id="element-61" data-mp="365rb80l0cabo">{t(ui.contact.callLabel)}</span>
              <span className="block font-display text-2xl font-bold sm:text-3xl" data-id="element-62" data-mp="2s686zivbhj4n">{business.phoneDisplay}</span>
            </span>
          </a>
          <a href={business.emailHref} className="flex items-center gap-4 rounded-sm border border-gold/50 px-6 py-5 transition-[border-color] duration-150 ease-out hover:border-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold md:col-span-2" data-id="element-63" data-mp="qcim2m75jay6">
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-gold/50 text-gold" data-id="element-64" data-mp="1yc7useixsm9p">
              <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-65" data-mp="1ubp08cpnt23t" />
            </span>
            <span className="min-w-0" data-id="element-66" data-mp="1pckszrmapeg4">
              <span className="block text-xs font-bold uppercase tracking-[0.16em] text-gold" data-id="element-67" data-mp="1pdngrqobn0rt">{t(ui.contact.emailLabel)}</span>
              <span className="block break-all text-[15px] font-semibold text-white" data-id="element-68" data-mp="2i0gk8gt3ie5i">{business.email}</span>
            </span>
          </a>
        </Reveal>

        <Reveal className="mt-6" data-id="element-69" data-mp="2d86zrgar26am">
          <ContactForm data-id="element-70" data-mp="2d7f4k6l2eakv" />
        </Reveal>

        <Reveal className="mt-8 flex flex-col items-center gap-2 text-center text-sm" data-id="element-71" data-mp="289lyrenobil4">
          <p className="font-display text-lg italic text-gold" data-id="element-72" data-mp="35qklihita1tc">{t(ui.contact.promise)}</p>
          <p className="flex items-center gap-2 text-white/80" data-id="element-73" data-mp="30ysw4abe624s">
            <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-74" data-mp="30x9fujpqjr30" />
            {t(ui.contact.guarantee)}
          </p>
        </Reveal>

        <LocationMap data-id="element-75" data-mp="3d8scfl7z2bqn" />
      </div>
    </section>;
}